module.exports = __webpack_public_path__ + "static/media/td.024e1d49.svg";